import * as React from 'react'
import { isUserAuthenticated } from '$services/session/isAuthenticated/isAuthenticated.service'
import { RouteProps } from 'react-router'
import { PublicHeader } from './PublicHeader'
import PrivateLayout from './PrivateLayout'
import { Container } from './Container'

const Layout: React.SFC<RouteProps & Props> = ({ children, kids }) => {
  if (isUserAuthenticated()) {
    return <PrivateLayout>{children}</PrivateLayout>
  }
  return (
    <>
      <PublicHeader kids={kids} />
      <Container>{children}</Container>
    </>
  )
}

export default Layout



// WEBPACK FOOTER //
// ./src/views/components/Layout/Layout.tsx